import { render, staticRenderFns } from "./FixedPriceTaskBilling.vue?vue&type=template&id=0baf7fd4&scoped=true"
import script from "./FixedPriceTaskBilling.vue?vue&type=script&lang=js"
export * from "./FixedPriceTaskBilling.vue?vue&type=script&lang=js"
import style0 from "./FixedPriceTaskBilling.vue?vue&type=style&index=0&id=0baf7fd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baf7fd4",
  null
  
)

export default component.exports